module.exports = __webpack_public_path__ + "static/media/191IT205.c1a54aa2.jpeg";